export const defaultOrgRoles = {
    admin: {
        label: 'Administrator',
        permissions: [
            'view-members',
            'view-and-message-members',
            'view-and-transfer-members',
            'manage-members',
            'manage-organization',
            'view-organization-history',
            'manage-profile-picture',
        ],
    },
    user: {
        label: 'Recipient',
        permissions: [],
        default: true,
    },
};
